import { Component, OnInit } from '@angular/core';
import { GalleryPageServiceService } from './gallery-page-service.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
declare var $: any;
@Component({
  selector: 'app-gallery-page',
  templateUrl: './gallery-page.component.html',
  styleUrls: ['./gallery-page.component.scss']
})
export class GalleryPageComponent implements OnInit {

  // images: any[] = [];
 images1: { id: number; name: string; url: SafeUrl }[] = [];

  constructor(private GalleryPageService: GalleryPageServiceService,private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.loadGallery();
  }

 loadGallery(): void {
  this.GalleryPageService.getGallery().subscribe(
    (response: any[]) => {
      this.images1 = response.map(item => {
        if (item.fileData) {
          // If fileData is a base64 string, create a SafeUrl using data URI scheme
          const safeUrl = this.sanitizer.bypassSecurityTrustUrl(
            'data:image/png;base64,' + item.fileData
          );
          return {
            id: item.id,
            name: item.name,
            url: safeUrl,
          };
        } else {
          return {
            id: item.id,
            name: item.name,
            url: '',
          };
        }
      });
    },
    (error) => {
      console.error('Error loading gallery', error);
    }
  );
}

}


